module.exports = __webpack_public_path__ + "static/media/placas_500x325.c90b748e.png";